export default __webpack_public_path__ + "static/media/a011-2.9ca6741f.svg";